<!-- Navigation -->
<treo-vertical-navigation class="theme-dark"
                          [appearance]="'classic'"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [opened]="!isScreenSmall">

  <div treoVerticalNavigationContentHeader>

    <!-- Actions -->
    <div class="actions">

      <!-- Logo -->
      <div class="logo">
        <app-logo></app-logo>
      </div>

      <!-- Spacer -->
      <div class="spacer"></div>

      <!-- Notifications -->
      <notifications></notifications>

      <!-- User -->
      <user [showAvatar]="false"></user>
    </div>

    <!-- User -->
    <div class="user">
      <div class="avatar">
        <img [src]="user.profilePicture">
      </div>
      <div class="info">
        <div class="name">{{user.firstName}} {{user.lastName}}</div>
        <div class="email text-secondary">{{user.emailId}}</div>
      </div>
    </div>
  </div>

  <div treoVerticalNavigationContentFooter>
    <div class="logo">
      <img src="assets/images/logo/logo-text-on-dark.svg">
    </div>
  </div>

</treo-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">

  <!-- Header -->
  <div class="header">

    <!-- Navigation toggle button -->
    <button class="navigation-toggle-button"
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'menu'"></mat-icon>
    </button>

    <!-- Spacer -->
    <div class="spacer"></div>

    <!-- Search -->
    <search [appearance]="'bar'"></search>

    <!-- Shortcuts -->
    <shortcuts></shortcuts>

    <!-- Messages -->
    <messages></messages>

  </div>

  <!-- Content -->
  <div class="content">

    <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
         it won't register the changes on the layout and won't update the view. -->
    <router-outlet *ngIf="true"></router-outlet>
    <ngx-loader [fullScreen]="true" name="ball-atom"></ngx-loader>

  </div>

</div>
